module.exports = __webpack_public_path__ + "5971e4a96c5315d99b93c47a10ab36da.glb";